import { Map } from 'immutable';

import actions from '../constants/ApiActions';
import registerActions from '../constants/RegisterActions';
import { createReducer } from '../lib/ReducerUtils';

/* key names in use */
export const IS_REGISTERING_KEY = 'isRegistering';
export const REGISTRATION_ERROR_KEY = 'registrationError';
export const IS_BLOCKED_FROM_REGISTRATION = 'isBlockedFromRegistration';
export const REGISTRATION_ERROR_CODE_KEY = 'registrationErrorCode';

const INITIAL_STATE = Map({
  [IS_REGISTERING_KEY]: false,
  [REGISTRATION_ERROR_KEY]: '',
  [REGISTRATION_ERROR_CODE_KEY]: null,
  [IS_BLOCKED_FROM_REGISTRATION]: false,
});

// REGISTER REDUCER
export default createReducer(INITIAL_STATE, {
  [actions.REGISTER_ATTEMPT]: registerAttempt,
  [actions.REGISTER_SUCCESS]: registerSuccess,
  [actions.REGISTER_FAIL]: registerFail,
  [registerActions.REGISTER_RESET]: registerReset,
  [registerActions.REGISTER_CLEAR_ERROR]: registerClearError,
  [registerActions.REGISTER_BLOCKED]: registerBlocked,
});

// CASE FUNCTIONS

function registerAttempt(state) {
  return state.merge({
    [IS_REGISTERING_KEY]: true,
    [REGISTRATION_ERROR_CODE_KEY]: null,
    [REGISTRATION_ERROR_KEY]: '',
  });
}

function registerSuccess(state) {
  return state.merge({
    [IS_REGISTERING_KEY]: false,
    [REGISTRATION_ERROR_KEY]: '',
  });
}

function registerFail(state, action) {
  return state.merge({
    [IS_REGISTERING_KEY]: false,
    [REGISTRATION_ERROR_CODE_KEY]: action.error.errorType || null,
    [REGISTRATION_ERROR_KEY]: action.error.errorMessage,
  });
}

function registerReset(state) {
  return state.merge({
    [IS_REGISTERING_KEY]: false,
    [REGISTRATION_ERROR_KEY]: '',
    [REGISTRATION_ERROR_CODE_KEY]: null,
    [IS_BLOCKED_FROM_REGISTRATION]: false,
  });
}

function registerClearError(state) {
  return state.set(REGISTRATION_ERROR_CODE_KEY, null);
}

function registerBlocked(state) {
  return state.set(IS_BLOCKED_FROM_REGISTRATION, true);
}
